import { Icon } from '@iconify/react';
import androidFilled from '@iconify/icons-ant-design/android-filled';
// material
import { alpha, styled } from '@mui/material/styles';
import { Card, Container, Typography, CircularProgress, Button, Box } from '@mui/material';
// utils
import { fShortenNumber,fNumber } from '../../../utils/formatNumber';
import checkOutlined from '@iconify/icons-ant-design/check-outlined';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(2, 2),
  color: '#22577A',
  backgroundColor: '#ffffff',
  height: 250,
  display: "flex", 
  flexDirection: 'column',
  justifyContent: "center",
}));

// ----------------------------------------------------------------------
// calculate average age of active patients (visited practice at least once in last year)
const TOTAL = '16,540';
const AVERAGE = '1,342';

function AppWeeklySales(props) {
  
  if (props.loading) {
    return (
      <Container 
      sx={{
        height: 'auto',
        minHeight: 250,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',

        alignItems: 'center',
      }}>
        <CircularProgress
          style={{
            marginTop: '20px',
            alignSelf: 'center',
          }}
        />
      </Container>
    );
  }

  return (
    <RootStyle>
    <Box sx={{ height: 208, border: 1, borderRadius: 2, borderColor: "secondary" }}>
      <br />
      <Typography variant="h5" color='#AA3377'>{fNumber(props.prescriptions.total)}</Typography>
      <Typography variant="subtitle2" >
       Number of prescriptions.
      </Typography>
      <br />
      <Typography variant="subtitle2" >Monthly average:</Typography>
      <Typography variant="h5" color='#AA3377'>{fNumber(props.prescriptions.monthly_avg)}</Typography> 
      <br />
      <Button fullWidth style={{ whiteSpace: 'nowrap' }} variant="contained" color='secondary' href='#prescriptions'>See more on prescriptions</Button>     
    </Box>
    </RootStyle>
  );
}

import { connect } from "react-redux";
const mapState = state => ({
  loading: state.overview.loading1,
  prescriptions: state.overview.prescriptions
 });
 
 const mapDispatch = ({ 
  overview: {loadData}}) => ({
    loadData: () => loadData()
 });
 
 export default connect(mapState, mapDispatch)(AppWeeklySales);

